import { homApi } from '~/redux/apis/hom'

import { PetState } from '~/redux/slices/pet-state'

import { getFirebase } from '~/firebase'

const initialPetState: PetState = {
  currentAffectionLevel: 50,
  currentMathEnergyLevel: 0,
  currentTrickLearning: null,
  currentTrickProgress: 0,
  dragonPresent: false,
  dragonRank: 0,
  eggChosen: null,
  eggState: 0,
  hatchingCooldown: 0,
  hatchingEnergyCooldown: [0, 0, 0, 0, 0],
  kudosOrbs: 0,
  lastTimeStamp: 0,
  level: 0,
  lifeLength: 0,
  name: 'Mathagon',
  stillHatching: true,
  totalAffection: 0,
  totalMathEnergy: 0,
  trickLearningCooldown: 0,
  tricksLearned: [],
}

export const petStateApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getPetState: builder.query<PetState, number>({
      queryFn: async (userId) => {
        const { getDoc, doc, fireStore } = await getFirebase()
        const petStateDocument = await getDoc(doc(fireStore, 'users', String(userId), 'homebase', 'pet-state'))
        const fetchedPetState = petStateDocument.data() as PetState | undefined
        const newPetState = fetchedPetState || initialPetState

        return {
          data: newPetState,
        }
      },
    }),
  }),
})

export const { useGetPetStateQuery } = petStateApi
